import { getApi, postApi, putApi } from './Api';
import ReactSecureStorage from 'react-secure-storage';

export const getAccountList = async (count) => {
  const url = `/admin/member/admin-account/list?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getSearchAccountNameList = async (value, count) => {
  const url = `/admin/member/admin-account/getHospitalName/page/${value}?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getSearchAccountEmailList = async (value, count) => {
  const url = `/admin/member/admin-account/getEmail/page/${value}?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getAccountID = async (id) => {
  const url = `/admin/member/admin-account/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const saveAccount = async (data) => {
  const url = `/admin/member/admin-account/register`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const updateAccount = async (data) => {
  const url = `/admin/member/admin-account/edit-profile`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const checkPassword = async (email, password) => {
  const url = `/admin/member/admin-account/check-password?email=${email}&password=${password}`;
  try {
    const response = await getApi(url);
    // if()
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const changePassword = async (data) => {
  const url = `/admin/member/admin-account/change-password`;
  try {
    const response = await postApi(url, data);
    if (response.statusCode === 200) {
      // window.localStorage.setItem(
      //   'accessToken',
      //   response.data.tokenInfo.accessToken,
      // );
      // window.localStorage.setItem(
      //   'refreshToken',
      //   response.data.tokenInfo.refreshToken,
      // );
      ReactSecureStorage.setItem('accessToken', response.data.tokenInfo.accessToken);
      ReactSecureStorage.setItem('refreshToken', response.data.tokenInfo.refreshToken);
      return response;
    } else {
      console.log('Error => ', response);
      return response;
    }
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getAccount = async (id) => {
  const url = `/admin/distributor/both/get-account/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};